// Layout styles for the shared OnboardingShell. Card frame, brand row, step
// indicator, eyebrow, title, description. Form atoms (input, button, etc.)
// live in ./onboarding-form.styles.ts so multiple gate pages can reuse them.

import type { CSSProperties } from "react";

export const wrap: CSSProperties = {
  minHeight: "var(--vh-full)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "var(--sz-space-7)",
  background: "var(--sz-bg-base)",
};

export const card: CSSProperties = {
  width: "100%",
  maxWidth: "560px",
  background: "var(--sz-bg-surface)",
  border: "1px solid var(--sz-border-default)",
  borderRadius: "var(--sz-radius-lg)",
  padding: "44px 40px",
  display: "flex",
  flexDirection: "column",
  gap: "var(--sz-space-5)",
};

export const brandRow: CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: "var(--sz-space-3)",
  flexWrap: "wrap",
};

export const stepIndicator: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  gap: "var(--sz-space-2)",
};

export const stepDots: CSSProperties = {
  display: "flex",
  gap: "6px",
};

const baseDot: CSSProperties = {
  width: "8px",
  height: "8px",
  borderRadius: "50%",
  border: "1px solid var(--sz-border-default)",
  background: "transparent",
};

export const stepDot: CSSProperties = baseDot;

export const stepDotActive: CSSProperties = {
  ...baseDot,
  background: "var(--sz-amber)",
  border: "1px solid var(--sz-amber)",
};

export const stepDotDone: CSSProperties = {
  ...baseDot,
  background: "var(--sz-amber-dim)",
  border: "1px solid var(--sz-amber-dim)",
};

export const stepLabel: CSSProperties = {
  fontFamily: "var(--sz-font-mono)",
  fontSize: "var(--sz-mono-xs)",
  letterSpacing: "2px",
  textTransform: "uppercase",
  color: "var(--sz-text-muted)",
};

export const eyebrow: CSSProperties = {
  fontFamily: "var(--sz-font-mono)",
  fontSize: "var(--sz-mono-sm)",
  letterSpacing: "3px",
  textTransform: "uppercase",
  color: "var(--sz-amber-text)",
};

export const title: CSSProperties = {
  fontFamily: "var(--sz-font-head)",
  fontSize: "26px",
  fontWeight: 700,
  color: "var(--sz-text-primary)",
  lineHeight: 1.15,
};

export const description: CSSProperties = {
  fontFamily: "var(--sz-font-body)",
  fontSize: "var(--sz-body-md)",
  color: "var(--sz-text-secondary)",
  lineHeight: 1.65,
};
